import { queryOptions } from '@tanstack/react-query'

import { api, unwrap } from '@/lib/api/client'

export const orgQueries = {
  /**
   * The org being worked in: its name, the member's role there and its settings (the timezone
   * every date is shown in). Keyed by org, so working in another org never shows this one's. It
   * names its org to the API itself, so an org can be loaded before the scope moves to it.
   */
  current: (orgId: string | null) =>
    queryOptions({
      queryKey: ['orgs', 'current', orgId] as const,
      queryFn: async () =>
        unwrap(
          await api.GET('/api/v1/orgs/current', {
            headers: orgId === null ? undefined : { 'X-Org-ID': orgId },
          }),
        ),
      staleTime: 5 * 60 * 1000,
    }),
}
